import { type UseFormReturn } from "react-hook-form";
import { type z } from "zod";

import { TextInput } from "@components/v2/inputs";

import { type ClientSettingSchema } from "./client-setting-form";

type Props = {
  formMeta: UseFormReturn<z.infer<typeof ClientSettingSchema>>;
};

export const SettingNameField = ({ formMeta }: Props) => {
  return (
    <div className="border-b border-v2-secondary px-6 pt-6 pb-8">
      <label className="block font-semibold">1. Type your setting’s name</label>
      <TextInput
        className=""
        autoCapitalize="off"
        autoCorrect="off"
        autoComplete="off"
        placeholder="eg. Revenue optimization setting..."
        errorMessage={formMeta.formState.errors.name?.message}
        {...formMeta.register("name")}
      />
    </div>
  );
};
